import React from 'react';

export const PanelHeader: React.FC<{ children: any; width?: string; height?: string }> = ({ children, width, height }) => {
    const setStyle = {
        width: `${width}`,
        height: `${height}`,
    };

    return (
        <>
            <div
                className='panelheader'
                style={setStyle}
            >
                {children}
            </div>
        </>
    );
};
